(function () {
    'use strict';

    angular.module('app.layout')
      .directive('spBindHtmlCompile', bindHtmlCompile);;

    bindHtmlCompile.$inject = ['$compile'];
    /* @ngInject */
    function bindHtmlCompile($compile) {
        var directive = {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.spBindHtmlCompile);
                }, function (value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                });
            }
        };
        return directive;
    }
}());